export const fetchJobList = async ({
    BeURL,
    showAlert,
    setJobs,
    setPagination,
    setAllJobs,
    page = 1,
    perPage = 10,
    search = "",
    key,
    rangeFilter,
    MAX_CLIENT_FETCH = 1000
}) => {
    try {
        const params = { page, perPage };

        if (search) params.search = search;

        if (rangeFilter && typeof rangeFilter === "object") {
            const { type, value, fromDate, toDate } = rangeFilter;
            if (type) params.type = type;
            if (value) params.value = value;
            if (fromDate) params.fromDate = fromDate;
            if (toDate) params.toDate = toDate;          
        }

        if (typeof key !== "undefined") params.key = key;

        const query = new URLSearchParams(params).toString();

        const res = await fetch(`${BeURL}/list-jobs?${query}`, {
            credentials: "include"
        });

        const data = await res.json();

        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setJobs(data.jobs || []);

        setPagination(
            data.pagination || {
                currentPage: page,
                perPage,
                totalPages: 1,
                totalCount: (data.jobs || []).length
            }
        );

        const totalCount =
            data.pagination?.totalCount ?? (data.jobs || []).length;

        if (totalCount && totalCount <= MAX_CLIENT_FETCH) {
            try {
                const allRes = await fetch(
                    `${BeURL}/list-jobs?page=1&perPage=${totalCount}`,
                    { credentials: "include" }
                );
                const allJson = await allRes.json();

                if (allJson.success) {
                    setAllJobs(allJson.jobs || []);
                } else {
                    setAllJobs(data.jobs || []);
                }
            } catch {
                setAllJobs(data.jobs || []);
            }
        } else {
            setAllJobs([]);
        }

    } catch (err) {
        console.error("Error in job list fetch:", err);
        showAlert("Unable to fetch jobs.");
    }
};


export const DeleteJobs = ({ BeURL, showAlert, endpoint, ids , message}) => {
    if (!ids.length) {
        showAlert('No jobs selected');
        return;
    }
    if (!window.confirm(`Proceed to ${message}?`)) return;
    fetch(`${BeURL}/${endpoint}`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids })
    })
        .then(r => r.json())
        .then(data => {
            showAlert(data.message);

        })
        .catch(() => showAlert('Action failed'));
}
